import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "../ui/input";

export const PasswordInput = ({ className = "", "data-testid": testid, ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input {...props} type={show ? "text" : "password"} className={`pr-12 ${className}`} data-testid={testid} />
      <button type="button" onClick={() => setShow((s) => !s)} aria-label={show ? "Sembunyikan kata sandi" : "Tampilkan kata sandi"}
        title={show ? "Sembunyikan kata sandi" : "Tampilkan kata sandi"} aria-pressed={show}
        className="absolute inset-y-0 right-0 flex w-12 items-center justify-center text-slate-500 hover:text-emerald-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-700/40 rounded-r-md"
        data-testid={testid ? `${testid}-toggle` : undefined}>
        {show ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
      </button>
    </div>
  );
};
